import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { PAGES_SERVICES_PATHS } from './pages-services';

import { AccessDeniedComponent } from './access-denied/access-denied.component';
import { AuthGuard } from '../auth/auth.guard.service';

const routes: Routes = [
  {
    path: PAGES_SERVICES_PATHS.access_denied,
    component: AccessDeniedComponent,
    canActivate: [AuthGuard],
    data: { animation: 'AccessDenied' },
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class PagesServicesRouting {}
